import script from "./RelationGallery.vue?vue&type=script&setup=true&lang=js"
export * from "./RelationGallery.vue?vue&type=script&setup=true&lang=js"

import "./RelationGallery.vue?vue&type=style&index=0&id=0d1c0b3c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d1c0b3c"]])

export default __exports__